<template>
  <div>
    <PageAllow controller="SubAccountAnalyses" action="subAccountOrders" />
    <Breadcrumbs :items="items" />

    <v-sheet class="overflow-y-scroll fill-content-height">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRange
              v-model="selectedDates"
              type="datetime"
              :label="$t('subAccountQuery.create_time')"
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-spacer />
            <!-- 批量分账明细导出 -->
            <v-btn
              v-if="
                $permission.permissionAllow(
                  'SubAccountAnalyses',
                  'subAccountOrderExport'
                )
              "
              small
              color="print"
              class="ms-1"
              dark
              @click.stop="batchExportOrdersDetail()"
            >
              <v-icon x-small class="pe-1">fa-file-excel</v-icon>
              {{ $t("subAccountQuery.batchExportSplitDetails") }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <!--订单编号 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="order_code"
                  v-model="options.order_code"
                  @text="orderCodeKeyword = $event"
                  :label="$t('subAccountQuery.order_code')"
                />
              </v-col>
              <!--账单编号 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherKeyword
                  ref="bill_code"
                  v-model="options.bill_code"
                  @text="billCodeKeyword = $event"
                  :label="$t('subAccountQuery.bill_code')"
                />
              </v-col>
              <!-- 客户 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherShops v-model="shopsSelected" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherSubAccount v-model="subAccountSelected" />
              </v-col>
              <v-col cols="12" sm="6" md="8">
                <SearcherSubAccountType v-model="options.sub_account_type" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStatus
                  v-model="options.pay_flgs"
                  :label="$t('SubAccountAnalyses.payFlags')"
                  :items="payFlgsItems"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherStatus
                  v-model="options.order_status"
                  :label="$t('SubAccountAnalyses.orderStatus')"
                  :items="orderStatusItems"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="subAccountQuery"
          :options.sync="options"
          :server-items-length="paging.count"
          :loading="loading"
          multi-sort
          class="elevation-1 px-4 pt-1"
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.fee="{ item }"
            >{{ $t("Global.money") }} {{ item.fee | formatMoney }}</template
          >
          <template v-slot:item.sub_account_money="{ item }">
            <a
              @click="
                subAccountDialog = true;
                currentItem = item;
              "
            >
              {{ $t("Global.money") }}
              {{ item.sub_account_money | formatMoney }}
            </a>
          </template>
          <template v-slot:item.order_code="{ item }">
            <span class="text-no-wrap caption font-weight-bold">
              {{ item.order_code }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.order_created_time | formatTime }}
            </span>
          </template>
          <template v-slot:item.shop_name="{ item }">
            {{
              $t("subAccountQuery.shop_name", [item.shop_code, item.shop_name])
            }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              v-if="
                $permission.permissionAllow(
                  'SubAccountAnalyses',
                  'subAccountOrderView'
                )
              "
              small
              outlined
              color="info"
              class="px-2 me-2"
              :href="'/#/sub-account-orders/' + item.order_id"
            >
              <v-icon x-small class="pe-1">fa-align-left</v-icon>
              {{ $t("Opt.details") }}
            </v-btn>
          </template>
        </v-data-table>
      </div>
      <SubAccountDialog v-model="subAccountDialog" :currentItem="currentItem" />
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRange from "@/components/plugins/SearcherDatetimeRange";
import SearcherSubAccount from "@/components/plugins/SearcherSubAccount";
import SearcherSubAccountType from "@/components/plugins/SearcherSubAccountType";
import SubAccountAnalyses from "@/api/sub_account_analyses";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherShops from "@/components/plugins/SearcherShops";
import SubAccountDialog from "./plugins/SubAccountDialog";

const defaultOptions = {
  created_time_from:
    new Date(new Date().getTime() - 31 * 24 * 3600 * 1000) // 从昨天算起再往前三十天内
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59", // 截止到今天
  sub_account_id: 0,
  sub_account_type: [],
  sortBy: [],
  sortDesc: [],
  pay_flgs: [3], //账单支付状态
  order_status: [6], //订单状态
  order_code: "", //订单编号
  bill_code: "", //账单编号
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRange,
    SearcherSubAccount,
    SearcherSubAccountType,
    SearcherStatus,
    SearcherKeyword,
    SearcherShops,
    SubAccountDialog,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.subAccountQuery"),
        disabled: true,
        href: "/sub-account-query",
      },
    ],
    headers: () => [
      {
        text: i18n.t("subAccountQuery.Fields.order_code"),
        align: "start",
        sortable: false,
        value: "order_code",
      },
      {
        text: i18n.t("subAccountQuery.Fields.bill_code"),
        align: "start",
        sortable: false,
        value: "bill_code",
      },
      {
        text: i18n.t("subAccountQuery.Fields.shop_name"),
        align: "start",
        sortable: false,
        value: "shop_name",
      },
      {
        text: i18n.t("subAccountQuery.Fields.billPrice"),
        align: "start",
        sortable: false,
        value: "fee",
      },
      {
        text: i18n.t("subAccountQuery.Fields.splitTotal"),
        align: "start",
        sortable: false,
        value: "sub_account_money",
      },
      {
        text: i18n.t("subAccountQuery.Fields.orderStatus"),
        align: "start",
        sortable: false,
        value: "order_status_str",
      },
      {
        text: i18n.t("subAccountQuery.Fields.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    payFlgsItems() {
      return this.$consts.subAccountAnalyses.pay_flgs;
    },
    orderStatusItems() {
      return this.$consts.subAccountAnalyses.status;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  mounted() {
    // this.$store.commit("districtID", 0); // 本汇总中条目不体现地区，为避免误解每次进入页面重置为全部地区
    this.$store.commit("searchDistrict", false);
    this.$commonUtils
      .loadOptions("sub-account-query", ["shopsSelected", "subAccountSelected"])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
            if (
              typeof this.options.created_time_from != "undefined" &&
              typeof this.options.created_time_to != "undefined"
            )
              this.selectedDates = [
                this.options.created_time_from,
                this.options.created_time_to,
              ];
          } else this.resetSearch();

          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "subAccountSelected":
                this.subAccountSelected = selected.value;
                break;
              case "shopsSelected":
                this.shopsSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },

  data: () => ({
    selectedDates: [
      new Date().toISOString().substr(0, 10) + " 00:00:00",
      new Date().toISOString().substr(0, 10) + " 23:59:59",
    ],
    subAccountSelected: null,
    options: JSON.parse(JSON.stringify(defaultOptions)),
    paging: {},
    subAccountAnalyses: [],
    subAccountQuery: [],
    totalReceiveMoney: 0,
    totalSubAccountMoney: 0,
    totalCount: 0,
    totalShopCount: 0,
    dialog: false,
    total_receive_money: "",
    total_count: "",
    shopsSelected: null,
    subAccountDialog: false,
    currentItem: null,
  }),

  methods: {
    resetSearch() {
      this.subAccountSelected = null;
      this.shopsSelected = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      this.selectedDates = [
        this.options.created_time_from,
        this.options.created_time_to,
      ];
    },
    onSearch() {
      this.options = Object.assign(this.options, {
        order_code: this.orderCodeKeyword,
        bill_code: this.billCodeKeyword,
      });
    },
    onDateChange() {
      if (this.selectedDates.length < 2) return;
      if (typeof this.selectedDates[0] != "undefined")
        this.options.created_time_from = this.selectedDates[0];
      if (typeof this.selectedDates[1] != "undefined")
        this.options.created_time_to = this.selectedDates[1];
    },
    getSubAccountOrdersFromAPI() {
      SubAccountAnalyses.fetchOrders(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.subAccountQuery = response.data.orders;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    batchExportOrdersDetail() {
      SubAccountAnalyses.batchExportOrdersDetail(this.options);
    },
  },

  watch: {
    // districtID: {
    //   handler() {
    //     this.getSubAccountOrdersFromAPI();
    //   },
    // },
    selectedDates: {
      handler() {
        this.onDateChange();
      },
    },
    subAccountSelected: {
      handler() {
        this.options.sub_account_id = this.subAccountSelected
          ? this.subAccountSelected.id
          : 0;
        sessionStorage.setItem(
          "sub-account-query-subAccountSelected",
          this.subAccountSelected
            ? JSON.stringify(this.subAccountSelected)
            : null
        );
      },
    },
    options: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getSubAccountOrdersFromAPI();
        sessionStorage.setItem(
          "sub-account-query-options",
          JSON.stringify(this.options)
        );
      },
    },
    // 门店
    shopsSelected: {
      handler() {
        this.options.shop_ids = this.shopsSelected
          ? this.shopsSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "sub-account-query-shopsSelected",
          JSON.stringify(this.shopsSelected)
        );
      },
    },
  },

  beforeDestroy() {
    this.$store.dispatch("threadLoadingStopAll");
  },
};
</script>